<template>
  <div>
    <qb-table>
      <template v-slot:thead>
        <qb-tr style="width: 100vw">
          <qb-th class="f-14" style="width: 20vw">
            {{ $t('client') | capitalize }}
          </qb-th>
          <qb-th class="f-14" style="width: 25vw !important;">
            {{ $tc('vendor') | capitalize }}
          </qb-th>
          <qb-th class="f-14 text-center" style="width: 25vw">
            {{
              `${$t('folio')}|${$t('date')}|${$t('year')}-${$t('week')}|${$t(
                'pay_date'
              )}` | capitalize
            }}
          </qb-th>
          <qb-th class="f-14 text-center" style="width: 15vw">
            {{ $t('category') | capitalize }}
          </qb-th>
          <qb-th class="f-14 text-center" style="width: 10vw">
            {{ $t('total') | capitalize }}
          </qb-th>
          <qb-th class="f-14" style="width: 5vw"></qb-th>
        </qb-tr>
      </template>
      <template v-slot:tbody>
        <qb-tr v-for="(el, idx) in data" :key="idx">
          <qb-td>{{ el.ClientName | capitalize }}</qb-td>
          <qb-td style=" max-width: 20vw !important;">
            {{ el.VendorName[0] | capitalize }} <br v-if="el.VendorName[1]"/> {{ el.VendorName[1] | capitalize }}
          </qb-td>
          <qb-td class="text-center">
            {{ el.Folio }} <b>|</b> {{ formatDate(el.ExpenseDate) }} <b>|</b>
            {{ el.Year }}-{{ el.Week }} <b>|</b>
            {{ formatDate(el.PayDate) }}</qb-td
          >
          <qb-td>
            <span
              class="material-icons sm"
              :style="{
                fontSize: '8px',
                color: el.category_color,
              }"
            >
              lens
            </span>
            {{ el.CategoryName | capitalize }}
          </qb-td>
          <qb-td class="text-right"
            >$ {{ formatNumber(el.Total,2) }} {{ el.CurrencyId | capitalize }}
          </qb-td>
          <qb-td>
            <action-icon
              icon="SidebarIcon"
              :tooltip="$t('details') | capitalize"
              @click="showDetails(el.ExpenseId)"
          /></qb-td>
        </qb-tr>
        <qb-tr>
          <qb-td colspan="100%">
            <div
              v-if="data.length"
              v-observe-visibility="infiniteHandler"
            ></div>
          </qb-td>
        </qb-tr>
      </template>
    </qb-table>
  </div>
</template>

<script>
import QbTable from '@/views/qb-components/table/QbTable.vue'
import QbTr from '@/views/qb-components/table/QbTr.vue'
import QbTh from '@/views/qb-components/table/QbTh.vue'
import QbTd from '@/views/qb-components/table/QbTd.vue'
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
export default {
  name: 'expense-table',
  components: {
    ActionIcon,
    QbTable,
    QbTr,
    QbTh,
    QbTd,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    showDetails(id) {
      this.$emit('showDetails', id)
    },
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
  },
}
</script>

<style>
.chip-status {
  max-width: 9rem;
  min-width: 2rem;
  color: white;
  text-align: center;
  border-radius: 0.3em;
}
</style>
